import { useState, useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { useScrollReveal, getRevealStyle } from '@/hooks/useScrollReveal';

const logoUrl =
  'https://storage.readdy-site.link/project_files/fb9a032b-f905-4139-b305-3a12a0952c6a/59b69cfd-0953-4f81-8590-a303a1311dbd_compressed_unnamed.webp';

const CANONICAL_URL = 'https://giyao.sonbook.net/faq';
const SITE_URL = 'https://giyao.sonbook.net';

const faqCategories = [
  {
    category: '關於機曜文化',
    items: [
      {
        q: '機曜文化是什麼品牌？',
        a: '機曜文化（GIYAO）為機曜文化事業有限公司的對外品牌名稱，以科普類書籍為主要出版方向。品牌網站提供品牌介紹、科普出版方向、2026最新發行書籍、合作購書通路及崧博書籍資料庫入口。',
      },
      {
        q: '機曜文化與崧博出版是什麼關係？',
        a: '本品牌委託崧博出版經銷，官方網站由崧博出版製作。機曜文化是具有自身出版定位的出版品牌，委託經銷與網站製作不代表機曜文化為崧博旗下品牌、子品牌或自有品牌。',
      },
      {
        q: '機曜文化網站提供哪些資訊？',
        a: '網站主要提供品牌介紹、科普出版方向、2026最新發行書籍、合作購書通路、常見問題及崧博書籍資料庫入口。網站為出版品牌官網，不是科學研究機構、教育機構、醫療單位或科技服務平台。',
      },
    ],
  },
  {
    category: '書籍與出版資訊',
    items: [
      {
        q: '如何查詢機曜文化的出版書籍？',
        a: '可先瀏覽機曜文化品牌網站目前公開的科普出版內容。如需確認完整書名、作者、ISBN、出版日期及其他正式書目資訊，請前往崧博書籍資料庫查詢。',
      },
      {
        q: '網站上的書籍資料以哪裡為準？',
        a: '書名、作者、ISBN、出版日期及其他正式出版資訊，以崧博書籍資料庫中的個別書籍頁為準。',
      },
      {
        q: '機曜文化出版哪些類型的書籍？',
        a: '機曜文化以科普類書籍為主要出版方向，涵蓋自然科學、動植物、地球與環境、宇宙與天文、人體與健康知識、科技知識、世界知識及生活科學等閱讀主題。目前公開的出版內容以品牌網站與正式書目資料所列作品為準。',
      },
      {
        q: '網站上的內容簡介是完整內容嗎？',
        a: '網站上的內容簡介主要用於協助讀者了解書籍主題。完整內容、版本及實際出版資訊，仍請以正式出版品與崧博書籍資料庫的個別書籍頁為準。',
      },
      {
        q: '2026最新發行書籍如何判定？',
        a: '2026最新發行書籍只顯示正式出版年份為2026年，且已有確認書目資料的作品，並依正式出版日期由新到舊排列。',
      },
    ],
  },
  {
    category: '購書通路與庫存',
    items: [
      {
        q: '在哪裡可以購買機曜文化的書？',
        a: '可透過網站合作購書通路頁所列的正式平台查找。各作品實際上架平台可能不同，請以各通路頁面顯示為準。',
      },
      {
        q: '為什麼在某個平台找不到書籍？',
        a: '不同作品在各平台的上架狀態可能不同。建議先至崧博書籍資料庫確認正式書名、作者與ISBN，再前往其他已建立的合作通路查找。',
      },
      {
        q: '網站顯示的價格是最終售價嗎？',
        a: '書籍價格、折扣及促銷活動可能由各合作通路調整，實際售價請以通路頁面為準。',
      },
      {
        q: '網站可以查詢即時庫存嗎？',
        a: '機曜文化品牌網站不保證提供各通路即時庫存。實際庫存、配送及到貨資訊，請以各合作通路頁面為準。',
      },
      {
        q: '所有書籍都會在全部合作通路上架嗎？',
        a: '不一定。不同作品的上架平台、版本及供應狀態可能不同，實際情況請以各通路頁面為準。',
      },
      {
        q: '網站上的通路連結是官方購買連結嗎？',
        a: '請透過網站合作購書通路頁所列的平台連結前往查找，實際商品與購買資訊請以通路頁面為準。',
      },
    ],
  },
  {
    category: '書籍資料庫查詢',
    items: [
      {
        q: '什麼是崧博書籍資料庫？',
        a: '崧博書籍資料庫提供正式書目查詢入口，可用於確認書名、作者、ISBN、出版日期及其他已公開的出版資訊。Catalog是書籍出版資料的查詢入口，不是線上書店、電子書商城、科學研究資料庫或醫療知識平台。',
      },
      {
        q: '如何在書籍資料庫找到機曜文化的書？',
        a: '可使用正式書名、作者或ISBN進行查詢。若名稱較長，建議優先使用ISBN或完整書名確認。',
      },
      {
        q: '品牌網站與書籍資料庫的資料不同時，以哪一個為準？',
        a: '正式書名、作者、ISBN與出版日期，請以崧博書籍資料庫中的個別書籍頁為準；價格、版本、庫存與購買方式，則以各合作通路頁面為準。',
      },
    ],
  },
  {
    category: '品牌經銷與合作',
    items: [
      {
        q: '如何洽詢機曜文化品牌合作？',
        a: '如有機曜文化品牌經銷、通路合作、內容合作、媒體或其他相關合作需求，請透過網站現有的官方聯絡方式提出詢問。品牌經銷與合作方案詳情請直接聯繫洽詢。',
      },
      {
        q: '機曜文化是否提供出版代辦服務？',
        a: '機曜文化品牌網站目前不宣稱提供出版代辦、排版代工、印刷代工、發行代辦或上架代辦服務。',
      },
      {
        q: '機曜文化是否提供電子書或有聲書製作服務？',
        a: '機曜文化品牌網站目前不宣稱提供電子書、EPUB、POD或有聲書製作代工服務。',
      },
      {
        q: '機曜文化是否提供科學研究或科技服務？',
        a: '機曜文化是出版品牌，以科普類書籍為主要出版方向。機曜文化不提供科學研究、實驗室服務、醫療診斷、科技開發、軟體開發、AI系統、數位轉型或專業顧問服務。',
      },
      {
        q: '合作洽詢是否保證出版、上架或銷售？',
        a: '合作洽詢不代表保證出版、上架、曝光或銷售成果，實際合作內容仍需依雙方確認為準。',
      },
    ],
  },
  {
    category: '科普內容責任說明',
    items: [
      {
        q: '網站內容是否可取代專業意見？',
        a: '網站所呈現內容為出版與一般科普閱讀資訊，不能取代正式研究、專業教育、醫療診斷或其他專業意見。若書籍涉及人體、健康或醫療知識，仍屬一般科普閱讀內容，不能作為醫療診斷、疾病預測、用藥建議或個人化治療的依據。',
      },
      {
        q: '個別作品內容是否代表品牌立場？',
        a: '個別作品內容與作者觀點，不代表機曜文化或崧博出版的官方立場。作者資格屬於作者本人，不代表機曜文化具有科研、教育、醫療或科技機構資格。',
      },
    ],
  },
];

const allFaqItems = faqCategories.flatMap((cat) => cat.items);

const faqPageJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  '@id': `${CANONICAL_URL}#webpage`,
  url: CANONICAL_URL,
  name: '機曜文化常見問題',
  inLanguage: 'zh-TW',
  isPartOf: {
    '@id': `${SITE_URL}/#website`,
  },
  mainEntity: allFaqItems.map((item) => ({
    '@type': 'Question',
    name: item.q,
    acceptedAnswer: {
      '@type': 'Answer',
      text: item.a,
    },
  })),
};

const breadcrumbJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  '@id': `${CANONICAL_URL}#breadcrumb`,
  itemListElement: [
    {
      '@type': 'ListItem',
      position: 1,
      name: '首頁',
      item: `${SITE_URL}/`,
    },
    {
      '@type': 'ListItem',
      position: 2,
      name: '常見問題',
      item: CANONICAL_URL,
    },
  ],
};

function PageHeaderSection() {
  const { ref, isVisible } = useScrollReveal<HTMLElement>({ threshold: 0.1 });

  return (
    <section
      ref={ref}
      className="relative min-h-[100svh] flex items-center pt-14 md:pt-16 bg-background-50"
    >
      {/* Logo watermark */}
      <div className="absolute inset-0 pointer-events-none select-none overflow-hidden z-0 flex items-center justify-center">
        <img
          src={logoUrl}
          alt=""
          className="w-[600px] md:w-[800px] lg:w-[1000px] h-auto object-contain opacity-[0.06] rotate-[12deg] scale-110"
        />
      </div>

      <div className="relative z-10 w-full max-w-[1280px] mx-auto px-6 md:px-10 py-16 md:py-24">
        <div className="flex flex-col items-center text-center">
          <span
            style={getRevealStyle(isVisible, 0)}
            className="text-[10px] font-medium text-primary-400 tracking-[0.25em] uppercase font-label mb-8"
          >
            FAQ
          </span>

          <h1
            style={getRevealStyle(isVisible, 60)}
            className="font-heading text-5xl md:text-7xl lg:text-8xl font-bold text-foreground-100 leading-[1.05] tracking-tight text-glow"
          >
            機曜文化常見問題
          </h1>

          <div
            style={getRevealStyle(isVisible, 140)}
            className="mt-8 max-w-[640px] space-y-4"
          >
            <p className="text-sm text-foreground-400 leading-[1.9]">
              本頁整理機曜文化品牌網站常見問題，包含品牌介紹、科普出版方向、正式書目查詢、合作購書通路、價格與庫存，以及品牌經銷與合作洽詢方式。
            </p>
            <p className="text-sm text-foreground-500 leading-[1.9]">
              機曜文化（GIYAO）為機曜文化事業有限公司的對外品牌名稱，以科普類書籍為主要出版方向。本品牌委託崧博出版經銷，官方網站由崧博出版製作。
            </p>
            <div className="pt-4 mt-4 border-t border-primary-500/10">
              <p className="text-xs text-foreground-600 leading-[1.8]">
                本頁整理機曜文化常見問題，包含品牌介紹、科普出版方向、正式書目查詢、合作購書通路，以及品牌經銷與合作洽詢等資訊。
              </p>
              <p className="text-xs text-foreground-600 leading-[1.8] mt-2">
                完整書名、作者、ISBN、內容主題及相關出版資訊，以崧博書籍資料庫中的個別書籍頁為準；價格、庫存、版本及購買方式則以各合作通路頁面為準。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function FaqCategorySection({
  category,
  items,
  categoryIndex,
  openKey,
  onToggle,
  baseDelay,
}: {
  category: string;
  items: { q: string; a: string }[];
  categoryIndex: number;
  openKey: string | null;
  onToggle: (key: string) => void;
  baseDelay: number;
}) {
  const { ref, isVisible } = useScrollReveal<HTMLElement>({ threshold: 0.05 });

  return (
    <section
      ref={ref}
      className="bg-background-100"
    >
      <div className="w-full max-w-[1280px] mx-auto px-6 md:px-10 py-16 md:py-20">
        <div className="max-w-[900px] mx-auto">
          <h2
            style={getRevealStyle(isVisible, 0)}
            className="font-heading text-xl md:text-2xl font-bold text-foreground-100 leading-[1.2] tracking-tight mb-6"
          >
            {category}
          </h2>

          <div className="divide-y divide-primary-500/8">
            {items.map((item, i) => {
              const key = `${categoryIndex}-${i}`;
              const isOpen = openKey === key;
              const answerId = `faq-answer-${categoryIndex}-${i}`;
              const questionId = `faq-question-${categoryIndex}-${i}`;

              return (
                <div
                  key={key}
                  style={getRevealStyle(isVisible, baseDelay + i * 60)}
                  className="py-1"
                >
                  <button
                    id={questionId}
                    onClick={() => onToggle(key)}
                    aria-expanded={isOpen}
                    aria-controls={answerId}
                    className="w-full flex items-start justify-between py-5 text-left cursor-pointer group"
                  >
                    <div className="flex items-start gap-4 pr-4">
                      <span className="text-xs text-foreground-600 font-medium tabular-nums mt-0.5 shrink-0 font-label">
                        {String(i + 1).padStart(2, '0')}
                      </span>
                      <span className="text-sm font-medium text-foreground-300 leading-[1.6] group-hover:text-primary-400 transition-colors">
                        {item.q}
                      </span>
                    </div>
                    <span className={`shrink-0 w-6 h-6 flex items-center justify-center border transition-all duration-200 mt-0.5 ${
                      isOpen ? 'border-primary-400 text-primary-400' : 'border-primary-500/25 text-foreground-600 group-hover:border-primary-400/50'
                    }`}>
                      <i
                        className={`text-xs transition-transform duration-200 ${
                          isOpen ? 'ri-subtract-line' : 'ri-add-line'
                        }`}
                      />
                    </span>
                  </button>
                  <div
                    id={answerId}
                    role="region"
                    aria-labelledby={questionId}
                    className={`overflow-hidden transition-all duration-300 ${
                      isOpen ? 'max-h-96 pb-5' : 'max-h-0'
                    }`}
                  >
                    <p className="text-sm text-foreground-400 leading-[1.9] pl-8 pr-10">
                      {item.a}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}

function CatalogRedirectSection() {
  const { ref, isVisible } = useScrollReveal<HTMLElement>({ threshold: 0.1 });

  return (
    <section
      ref={ref}
      className="bg-background-50"
    >
      <div className="w-full max-w-[1280px] mx-auto px-6 md:px-10 py-16 md:py-24">
        <div className="flex flex-col items-center text-center max-w-[640px] mx-auto">
          <h2
            style={getRevealStyle(isVisible, 0)}
            className="font-heading text-2xl md:text-3xl font-bold text-foreground-100 leading-[1.2] tracking-tight"
          >
            查詢機曜文化正式書目
          </h2>
          <div
            style={getRevealStyle(isVisible, 60)}
            className="mt-5 w-12 h-0.5 bg-primary-500 mx-auto shadow-[0_0_8px_var(--tw-shadow-color)] shadow-primary-500/40"
          />
          <p
            style={getRevealStyle(isVisible, 80)}
            className="mt-5 text-sm text-foreground-400 leading-[1.9]"
          >
            如需確認完整書名、作者、ISBN、出版日期及其他正式出版資訊，請前往崧博書籍資料庫查詢。
          </p>
          <div
            style={getRevealStyle(isVisible, 120)}
            className="mt-8"
          >
            <a
              href="https://catalog.sonbook.net/"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-950 text-sm font-medium hover:bg-primary-400 transition-all duration-200 cursor-pointer whitespace-nowrap shadow-[0_0_20px_var(--tw-shadow-color)] shadow-primary-500/15"
            >
              查詢完整書目
              <i className="ri-arrow-right-up-line text-xs" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

function ChannelsRedirectSection() {
  const { ref, isVisible } = useScrollReveal<HTMLElement>({ threshold: 0.1 });

  return (
    <section
      ref={ref}
      className="bg-background-100"
    >
      <div className="w-full max-w-[1280px] mx-auto px-6 md:px-10 py-16 md:py-24">
        <div className="flex flex-col items-center text-center max-w-[640px] mx-auto">
          <h2
            style={getRevealStyle(isVisible, 0)}
            className="font-heading text-2xl md:text-3xl font-bold text-foreground-100 leading-[1.2] tracking-tight"
          >
            查看機曜文化合作購書通路
          </h2>
          <div
            style={getRevealStyle(isVisible, 60)}
            className="mt-5 w-12 h-0.5 bg-primary-500 mx-auto shadow-[0_0_8px_var(--tw-shadow-color)] shadow-primary-500/40"
          />
          <p
            style={getRevealStyle(isVisible, 80)}
            className="mt-5 text-sm text-foreground-400 leading-[1.9]"
          >
            機曜文化相關書籍可透過網站已建立的合作通路查找。價格、庫存、版本、配送與購買方式請以各通路頁面為準。
          </p>
          <div
            style={getRevealStyle(isVisible, 120)}
            className="mt-8"
          >
            <a
              href="https://sonbook.net/"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="inline-flex items-center gap-2 px-6 py-3 border border-primary-500/40 text-primary-400 text-sm font-medium hover:border-primary-400 hover:text-primary-300 hover:bg-primary-500/6 transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              前往崧博出版
              <i className="ri-arrow-right-up-line text-xs" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default function Faq() {
  const [openKey, setOpenKey] = useState<string | null>(null);

  const handleToggle = (key: string) => {
    setOpenKey((prev) => (prev === key ? null : key));
  };

  useEffect(() => {
    document.title = '機曜文化常見問題｜品牌介紹、科普出版與書目查詢';

    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute(
        'content',
        '查看機曜文化常見問題，了解品牌介紹、科普出版方向、正式書目查詢、合作購書通路，以及品牌經銷與合作洽詢方式。'
      );
    }

    let canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', CANONICAL_URL);
    }

    const faqScript = document.createElement('script');
    faqScript.type = 'application/ld+json';
    faqScript.id = 'faqpage-ld';
    faqScript.textContent = JSON.stringify(faqPageJsonLd);
    document.head.appendChild(faqScript);

    const bcScript = document.createElement('script');
    bcScript.type = 'application/ld+json';
    bcScript.id = 'breadcrumb-ld';
    bcScript.textContent = JSON.stringify(breadcrumbJsonLd);
    document.head.appendChild(bcScript);

    return () => {
      document.title = '機曜文化（GIYAO）｜科普類書籍、品牌介紹與出版資訊';
      if (metaDesc) {
        metaDesc.setAttribute(
          'content',
          '機曜文化（GIYAO）為機曜文化事業有限公司的對外品牌名稱，以科普類書籍為主要出版方向。本品牌委託崧博出版經銷，官方網站由崧博出版製作。'
        );
      }
      if (canonical) {
        canonical.setAttribute('href', SITE_URL + '/');
      }
      document.getElementById('faqpage-ld')?.remove();
      document.getElementById('breadcrumb-ld')?.remove();
    };
  }, []);

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <PageHeaderSection />
        {faqCategories.map((cat, ci) => (
          <FaqCategorySection
            key={ci}
            category={cat.category}
            items={cat.items}
            categoryIndex={ci}
            openKey={openKey}
            onToggle={handleToggle}
            baseDelay={ci * 20}
          />
        ))}
        <CatalogRedirectSection />
        <ChannelsRedirectSection />
      </main>
      <Footer />
    </div>
  );
}